import { useQuery } from '@tanstack/react-query';
import { fetchPatientContext } from '@/api/patientContext';

export function usePatientContext(phone: string | null, tenantId: string | null) {
  return useQuery({
    queryKey: ['patientContext', phone, tenantId],
    queryFn: () => fetchPatientContext(phone!, tenantId!),
    enabled: Boolean(phone && tenantId),
    staleTime: 2 * 60 * 1000,
    // Не ретраим если CCS просто недоступен — это тихий фоллбэк
    retry: (failureCount, error: unknown) => {
      // Если ответ пришёл (не сетевая ошибка), не ретраим
      if (error && typeof error === 'object' && 'response' in error) return false;
      return failureCount < 1;
    },
  });
}
